// Stub: unsupported native module — no-op on web/desktop
export default {};
